export default "<main class=\"sign-up\">\n    <app-sign-up-referral-code></app-sign-up-referral-code>\n</main>"